/**
 * @function fetcher
 * @description a fetcher handler for GET data
 */
export const fetcher = (url) => fetch(url).then((res) => res.json());
